import React, { Component } from 'react';
import { Row, Col } from 'antd';
import Modal from 'react-modal';
import cx from 'classnames';
import MailchimpSubscribe from "react-mailchimp-subscribe";
// import { TwitterShareButton } from 'react-twitter-embed';
import TwitterShareButton from 'react-twitter-embed/dist/components/TwitterShareButton';

const mailChimpUrl = "//getnifty.us18.list-manage.com/subscribe/post?u=dc9e5a971583376561c1596de&amp;id=2c49526ac8";

import 'antd/lib/grid/style/index.css';
import './styles.css';

import niftyLogo from '../assets/nifty-logo.svg';
import rightArrow from '../assets/right-arrow.svg';
import heroBg from '../assets/hero-bg.svg';
import largeScreenOneBg from '../assets/large-screen-one-bg.svg';
import largeScreenTwoBg from '../assets/large-screen-two-bg.svg';
import chromeExtBg from '../assets/chrome-ext-bg.svg';
import exampleCardOneBg from '../assets/example-card-one-bg.svg';
import exampleCardTwoBg from '../assets/example-card-two-bg.svg';
import heroIconOne from '../assets/hero-icon-01.svg';
import heroIconTwo from '../assets/hero-icon-02.svg';
import heroIconThree from '../assets/hero-icon-03.svg';
import browserChrome from '../assets/browser-chrome.svg';
import lgScreenOne from '../assets/large-screen-one.svg';
import lgScreenTwo from '../assets/large-screen-two.svg';
import heroImageMain from '../assets/hero-main-img.svg';
import halfScreenImg from '../assets/half-screen-landing-svg.svg';
import exampleCardOne from '../assets/example-card-one-svg.svg';
import exampleCardTwo from '../assets/example-card-two-svg.svg';

const cfg = {};

cfg.backgrounds = {
  imgs: {
    hero: heroBg,
    largeScreen0: largeScreenOneBg,
    largeScreen1: largeScreenTwoBg,
    chromeExtBg: chromeExtBg,
    exampleCard0: exampleCardOneBg,
    exampleCard1: exampleCardTwoBg,
  }
};

cfg.nav = {
  btnText: 'GET EARLY ACCESS'
};

cfg.hero = {
  title: 'Connect your teams and their apps over one shared view.',
  body: "Teams are using more apps than ever to get their work done but this can lead to scattered data and redundant workflows.\nNifty pulls together your teams' data across all of their apps to give one incredibly intuitive view over all your teams' information.",
  cols: [
    {
      title: 'Map out projects, teams and complex systems into one unified graph.',
      body: 'Nifty automatically weaves most of your data into the graph but you also have full control over customization of each graph. Unlike traditional diagramming tools, Nifty’s graph has realtime connections to your productivity apps so it’s always becoming richer and more useful for your team.',
      icon: heroIconOne
    },
    {
      title: 'Finally one place to anchor all of your teams’ information.',
      body: "Today’s complex software projects require many apps and your teams’ information quickly scatters. Nifty integrates with all your teams' favorite apps giving you one shared place for all your teams' information. Also your team will love Nifty’s blazing-fast search.",
      icon: heroIconTwo
    },
    {
      title: 'Nifty optimizes your teams’ workflows across all of their apps.',
      body: 'The Nifty Chrome Extension seamlessly integrates into your teams’ existing apps and workflows and it intelligently surfaces relevant information or actions while your team uses their apps. Often time Nifty can turn a redundant, multi-step workflow into a single-step workflow saving your team tons of time.',
      icon: heroIconThree
    },
  ],
};

cfg.signup = {
  titles: ['Be one of the first to try Nifty!', 'Sign up for early access with just your email.'],
  sendingMsg: "Signing up...",
  errorMsg: "😲 Something went wrong! Try again, make sure there's no typos!",
  successMsg: "🎉 Party on! You're in line for early access! 🎉"
};

cfg.largeScreen = [
  {
    title: 'Nifty allows anyone to effortlessly build intuitive graphs so your team can map out complex projects.',
    imgSrc: lgScreenOne,
    cols: [
      {
        title: 'Any type of data from any app can be connected to your graph.',
        body: 'The graph is an unlimited canvas for you and your team to map out complex projects, systems, and organizations. Pull in any type of data from any app and add it to your graph. Nifty will maintain a realtime connection to your apps keeping your graphs and data up-to-date with fast-moving, ever-changing projects.'
      },
      {
        title: 'Less whiteboarding and more understanding.',
        body: 'Whiteboards are a great tool for diagramming complex systems but it takes time to draw them out and sometimes concepts are still lost due to, “ah hem”, slightly inadequate drawing skills. What if you could pull up a fully-connected, live view of your network, project or team? What if you could hand-draw annotations on top of that view using a digital whiteboard, tablet or phone? Nifty does just that.'
      },
      {
        title: 'Let Nifty build all of your graph or just some of it.',
        body: 'Nifty uses its relational graph and realtime integrations to intelligently auto-build a graph for you then you can rapidly edit the graph to put your own finishing touches on it. Or build a graph from scratch.'
      }
    ]
  },
  {
    title: 'Nifty’s graph is flexible. You can build graphs for projects, org charts or even build a realtime health dashboard of your network.',
    imgSrc: lgScreenTwo,
    cols: [
      {
        title: 'Nifty has special integrations for realtime health monitoring.',
        body: 'Nifty provides built-in functionality like health ping monitoring of service endpoints, realtime “push” integrations for apps like PagerDuty or Splunk and mobile apps that give teams responding to alerts immediate visibility onto one, holistic view of their system’s state.'
      },
      {
        title: 'Have instant context and visibility when critical events call for it.',
        body: 'Apps like PagerDuty and Splunk are awesome but often times when teams are responding to these alerts there is confusion and lack of communication or shared context between the engineers responding. Nifty gives you instant shared context allowing first responders to resolve issues more quickly with more clarity on the overall system status.'
      },
      {
        title: 'Multiple teams can triage multiple simultaneous issues.',
        body: 'Sometimes alerts in the middle of the night can quickly turn into a game of finger-pointing. Skip the drama by having a single shared view over all the systems involved. Each team can maintain their own health graph and all graphs can be linked at any level to create a larger, unified graph of your entire network.'
      }
    ]
  },
];

cfg.halfScreen = {
  title: 'Keep teams in sync even across many different apps.',
  body: 'The Nifty Chrome Extension seamlessly integrates into your teams’ existing apps and workflows. It intelligently predicts the next action you want to take and lets you do it in one click without leaving your current app. You can even select multiple actions, cutting redundant workflows down to a single step.',
  imgSrc: halfScreenImg,
  cols: [
    {
      title: 'Relevant information at a glance, exactly when you need it.',
      body: 'Nifty uses it’s relational graph and some fancy A.I. magic to present relevant information to you from all of your apps while you’re on any app. The best part? Nifty’s get smarter as your team uses it- we take information overload and turn it on its head… bring it on!'
    },
    {
      title: 'Keep your favorites apps. Nifty makes them better!',
      body: 'At Nifty we believe strongly that all teams should get to use their favorite apps but still enjoy the benefits of a tightly-integrated solution. Our mission is to prove that the way forward is more apps, more innovation but less scattered data, less redundant workflows.'
    }
  ]
};

cfg.example = [
  {
    title: 'Nifty makes all of your apps more powerful. Also, it gives you superpowers!',
    body: 'What if a search in one app also searched all your apps? Nifty is always trying to predict how it might help you with your current task. Under-the-hood Nifty performs hundreds of operations and only presents them to you if it thinks it’ll help. \nNifty also has many controls for privacy and notifications.We believe strongly in the value of focus so not only did we design with focus in mind but we give full control to the user to decide how they’d prefer to interact with Nifty.',
    imgSrc: exampleCardOne,
    imgOnRight: true
  },
  {
    title: 'Less questions, confusion, and interruptions. More focused work.',
    body: 'Eliminate “work about work” tasks like unnecessary meetings, emails, chat conversations and other coordination tasks by simply allowing your teams’ to see the same data.\nUp to 61% of your teams’ time can be taken up by these “work about work” tasks.Nifty can help you recapture this time and bring your time spent doing actual, valuable work to a new level of uninterrupted focus.',
    imgSrc: exampleCardTwo,
    imgOnRight: false
  }
];

const t = (str) => str.split('\n').map((item, key) => (<span key={key}>{item}<br /></span>));

class LandingMinimal extends Component {

  constructor() {
    super();
    this.state = {
      modalVisible: false,
      modalType: 'email'
    };
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  showModal(type) {
    this.setState({
      modalVisible: true,
      modalType: type
    });
  }

  hideModal() {
    this.setState({
      modalVisible: false,
      modalType: 'email'
    });
  }

  renderTopNav(isFooter = false) {
    const { btnText } = cfg.nav;
    return (
      <div className="full-width-section">
        {!isFooter && this.renderBackground('hero')}
        <div className="responsive-section">
          <Row>
            <Col xs={24}>
              <nav className={cx("top-nav-container", { isFooter })}>
                <Row>
                  <Col md={4} xs={10}>
                    <img src={niftyLogo} alt="Nifty" className="nifty-logo-image" />
                  </Col>
                  <Col md={{ span: 5, offset: 15 }} xs={14} className="top-nav-cta-btn-container">
                    <div className="top-nav-cta-btn" onClick={() => this.showModal('email')}>
                      {btnText}
                      <img src={rightArrow} className="top-nav cta-btn" />
                    </div>
                  </Col>
                </Row>
              </nav>
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  renderBackground(bgName) {
    const { imgs } = cfg.backgrounds;
    return (
      <div className={cx("full-width-section", "bg")}>
        <img src={imgs[bgName]} className={cx("bg-img", "bg-" + bgName)} />
      </div>
    );
  }

  renderHero() {
    const {
      title, body, bodyTwo, cols
    } = cfg.hero;
    return (
      <div className="responsive-section">
        <Row>
          <Col md={24}>
            <section className="hero-container">
              <Row>
                <Col xs={24} md={10}>
                  <div className="hero-message">
                    <h1 className="hero-title">{title}</h1>
                    <span className="hero-body">{t(body)}</span>
                  </div>
                  <div className="hero-cta">
                    <a href="#" onClick={() => this.showModal('email')} className="hero-cta-btn">Join the Waiting List</a>
                    <a href="#" onClick={() => this.showModal('follow')} className="hero-cta-btn btn-secondary">Follow Us</a>
                  </div>
                </Col>
                <Col xs={24} md={14}>
                  <div className="hero-image-container">
                    <img src={browserChrome} className="browser-chrome" />
                    <img className="hero-image-main" src={heroImageMain} alt="" />
                  </div>
                </Col>
              </Row>
              <div className="hero-advantages">
                <Row gutter={{ md: 32 }}>
                  {cols.map((col) => (
                    <Col xs={24} md={8}>
                      <div className="hero-advantage">
                        <div className="hero-advantage-icon">
                          <img src={col.icon} alt="icon" />
                        </div>
                        <h2>{col.title}</h2>
                        <span>{col.body}</span>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </section>
          </Col>
        </Row>
      </div>
    );
  }

  renderSignup(isModal) {
    const { titles, sendingMsg, errorMsg, successMsg } = cfg.signup;
    const EmailForm = ({ status, message, onSubmit }) => {
      let email;
      const submit = () => onSubmit({
        EMAIL: email.value
      });
      const onKeyDown = (e) => {
        if (e.keyCode == 13) {
          submit();
        }
      }
      const progress = status === "sending";
      const error = status === "error";
      const success = status === "success";

      return (
        <div className={cx("beta-form", { progress, error, success })}>
          <input
            className="email-input"
            onKeyDown={onKeyDown}
            ref={node => (email = node)}
            type="email"
            placeholder="coolperson@coolcompany.com"
          />
          <button className="email-submit" onClick={submit}>
            <img src={rightArrow} />
          </button>
          <div className="status-message">
            {status === "sending" && <span>{sendingMsg}</span>}
            {status === "error" && <span>{message || errorMsg}</span>}
            {status === "success" && <span>{successMsg}</span>}
          </div>
        </div>
      );
    };
    const EmailSignUpForm = () => (
      <MailchimpSubscribe
        url={mailChimpUrl}
        render={({ subscribe, status, message }) => (<EmailForm onSubmit={formData => subscribe(formData)} status={status} message={message} />)}
      />
    );
    return (
      <div className={cx("full-width-section", isModal ? "signup-modal-section" : "signup-section")}>
        <div className="responsive-section">
          <Row type="flex" justify="center">
            <Col xs={24} md={isModal ? 22 : 14}>
              <h3 className="signup-title">{titles[0]}</h3>
              <h3 className="signup-title">{titles[1]}</h3>
              <div className="signup-entry-container">
                <EmailSignUpForm/>
              </div>
            </Col>
          </Row>
        </div>
        {isModal && <div className="modal-dismiss" onClick={this.hideModal}>CLOSE</div>}
      </div>
    );
  }

  renderFollow() {

    return (
      <div className="full-width-section signup-modal-section">
        <div className="responsive-section">
          <Row type="flex" justify="center">
            <Col md={22}>
              <h3 className="signup-title">Tell your friends on Twitter about Nifty!</h3>
              <h3 className="signup-title">(You can follow us after you Tweet.)</h3>
              <div className="twitter-btn-container">
                <TwitterShareButton
                  url={'https://niftylabs.io'}
                  options={{ text: 'Does your team have too many apps? Nifty connects teams and their data over one shared view!', hashtags: "devtools,productivity,focus,developer,projectmanagement", via: 'niftylabsinc', size: 'large', dnt: true }}
                />
              </div>
            </Col>
          </Row>
        </div>
        <div className="modal-dismiss" onClick={this.hideModal}>CLOSE</div>
      </div>
    )
  }

  renderLargeScreen(version = 0) {
    const { title, imgSrc, cols } = cfg.largeScreen[version];
    return (
      <div className="full-width-section">
        {this.renderBackground('largeScreen' + version)}
        <div className="responsive-section">
          <Row>
            <Col xs={24}>
              <section className="large-screen-container">
                <Row type="flex" justify="center">
                  <Col xs={24} md={20}>
                    <h1 className="large-screen-title">{title}</h1>
                  </Col>
                </Row>
                <Row type="flex" justify="center">
                  <Col xs={24}>
                    <div className="large-screen-image-container">
                      <img src={browserChrome} className="browser-chrome" />
                      <img src={imgSrc} className="large-screen-image" />
                    </div>
                  </Col>
                </Row>
                <div className="large-screen-advantages">
                  <Row gutter={{ md: 32 }}>
                    {cols.map((col) => (
                      <Col xs={24} md={8}>
                        <div className="large-screen-advantage">
                          <h2>{col.title}</h2>
                          <span>{col.body}</span>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </section>
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  renderHalfScreen() {
    const { title, body, cols, imgSrc } = cfg.halfScreen;
    return (
      <div className="full-width-section">
        {this.renderBackground('chromeExtBg')}
        <div className="responsive-section">
          <section className="half-screen-container">
            <Row>
              <Col xs={24} md={{ push: 11, span: 13}}>
                <div className="half-screen-message-container">
                  <Row>
                    <Col md={24}>
                      <h1 className="half-screen-title">{title}</h1>
                      <span className="half-screen-body">{body}</span>
                    </Col>
                  </Row>
                  <Row>
                    <div className="half-screen-advantages">
                      {cols.map((col) => (
                        <Col md={12}>
                          <div className="half-screen-advantage">
                            <h2>{col.title}</h2>
                            <span>{col.body}</span>
                          </div>
                        </Col>
                      ))}
                    </div>
                  </Row>
                </div>
              </Col>
              <Col xs={24} md={{span: 10, pull: 13}}>
                <div className="half-screen-browser-container">
                  <img src={browserChrome} className="half-browser-chrome" />
                  <img src={imgSrc} className="half-browser-github" />
                </div>
              </Col>
            </Row>
          </section>
        </div>
      </div>
    );
  }

  renderExample(version = 0) {
    const { title, body, imgOnRight, imgSrc } = cfg.example[version];
    return (
      <div className="full-width-section">
        {this.renderBackground('exampleCard' + version)}
        <div className="responsive-section">
          <section className={"example-container " + "example-" + version}>
            <Row>
              <Col md={{ span: 12, push: imgOnRight ? 0 : 12 }}>
                <div className={cx("example-message-container", { 'pad-left': !imgOnRight })}>
                  <h1 className="example-title">{title}</h1>
                  <div className="example-body">{t(body)}</div>
                </div>
              </Col>
              <Col md={{ span: 12, pull: imgOnRight ? 0 : 12 }}>
                <div className="example-image-container">
                  <img className="example-image" src={imgSrc} />
                </div>
              </Col>
            </Row>
          </section>
        </div>
      </div>
    );
  }

  render() {
    const { modalType } = this.state;
    return (
      <div className="root-container">
        {this.renderTopNav()}
        {this.renderHero()}
        {this.renderSignup()}
        {this.renderLargeScreen(0)}
        {this.renderLargeScreen(1)}
        {this.renderSignup()}
        {this.renderHalfScreen()}
        {this.renderExample(0)}
        {this.renderExample(1)}
        {this.renderSignup()}
        {this.renderTopNav(true)}
        <Modal
          isOpen={this.state.modalVisible}
          onRequestClose={this.hideModal}
          contentLabel="Be one of the first to try Nifty!"
          className="modal-container"
          overlayClassName="modal-overlay"
        >
          {modalType !== 'follow' && this.renderSignup(true)}
          {modalType === 'follow' && this.renderFollow()}
        </Modal>
      </div>
    )
  }
}

export default LandingMinimal;


// WEBPACK FOOTER //
// ./src/pages/index.js